import React from 'react';
import './Home.css';

const Home = () => (
  <div className="maincontainer">
    <h2 className="intro">Mathematics is not about number, equations, computations, or algorithms: it is about understanding. William Paul Thurston</h2>
  </div>
);

export default Home;
